import { API } from '@utils/axios'
import { appendParams } from '@utils/func'
import { IAPI } from 'AppTypes'

class UserStoreManagementAPI implements IAPI {
  prefix = '/UserStoreManagement'

  fetchList (params: TUserStoreManagementAPI.Params.list) {
    const url = appendParams(`${this.prefix}/stores`, params)
    return API.get(url)
  }

  searchList (params: TUserStoreManagementAPI.Params.Search) {
    const url = appendParams(`${this.prefix}/search`, params)
    return API.get(url)
  }

  fetchSingle (params: TUserStoreManagementAPI.Params.Detail) {
    const url = appendParams(`${this.prefix}/detail`, params)
    return API.get(url)
  }

  updateDetail (body: TUserStoreManagementAPI.Body.Update) {
    return API.post(`${this.prefix}/update`, body)
  }

  async sendCredentialGenRequest (data: any) {
    const response = await API.post(`${this.prefix}/CredentialGen`, data)
    return response.data
  }
}

export const userStoreManagementAPI = new UserStoreManagementAPI()
